var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-ad-top-banner",class:{'active-in-app': _vm.inApp}},[_c('div',{staticClass:"top-banner-img"})])}
var staticRenderFns = []

export { render, staticRenderFns }